import { useEffect, useState } from "react";
import { gameApi } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Coins } from "lucide-react";

export const AchievementRewardsAdmin = () => {
  const [rows, setRows] = useState(null);
  const load = () => gameApi.get("/game/admin/achievements").then((r) => setRows(r.data.achievements)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const save = async (aid, coins, grant_now) => {
    try {
      const { data } = await gameApi.put(`/game/admin/achievements/${aid}`, { coins: Number(coins) || 0, grant_now: !!grant_now });
      toast.success(grant_now ? `Saved & back-paid ${data.granted_to} player(s)` : "Reward saved");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  if (!rows) return <p className="py-6 text-center text-sm text-muted-foreground"><Loader2 className="inline animate-spin" size={15} /> Loading…</p>;
  return (
    <div className="space-y-2" data-testid="achievement-rewards-admin">
      <p className="text-xs text-muted-foreground">Set a coin reward for any achievement (current, past or future). Backgrounds are linked in the <b>Backgrounds</b> tab. "Save & back-pay" grants the coins to every player who already earned it (once each).</p>
      {rows.map((a) => (
        <div key={a.id} data-testid={`ach-reward-${a.id}`} className="flex flex-wrap items-center gap-2 rounded-2xl border border-border bg-card p-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-primary">{a.name}</p>
            <p className="text-[11px] text-muted-foreground">{a.desc}</p>
            {a.backgrounds.length > 0 && <p className="text-[10px] text-secondary">🖼 Background: {a.backgrounds.join(", ")}</p>}
          </div>
          <div className="flex items-center gap-1">
            <Coins size={14} className="text-amber-500" />
            <input data-testid={`ach-reward-coins-${a.id}`} defaultValue={a.coins} type="number" min={0}
              onBlur={(e) => Number(e.target.value) !== a.coins && save(a.id, e.target.value, false)}
              className="w-24 rounded-lg border border-border bg-background px-2 py-1 text-sm" placeholder="coins" />
          </div>
          <button data-testid={`ach-reward-grant-${a.id}`}
            onClick={(e) => { const inp = e.currentTarget.parentElement.querySelector("input"); save(a.id, inp.value, true); }}
            className="rounded-lg bg-primary px-2.5 py-1.5 text-[11px] font-bold text-primary-foreground">Save &amp; back-pay</button>
        </div>
      ))}
    </div>
  );
};
